/* @flow */
import * as React from 'react';

const Clothing = props => (
  <svg
    width={127}
    height={91}
    viewBox="0 0 127 91"
    fillRule="evenodd"
    stroke="#1C1F34"
    strokeWidth={3}
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}>
    <path
      stroke="none"
      strokeWidth={1}
      fill="#DEDEDE"
      d="M63.426,4.294 C63.426,5.837 58.3,7.088 51.978,7.088 C45.655,7.088 40.529,5.837 40.529,4.294 C40.529,2.751 45.655,1.5 51.978,1.5 C58.3,1.5 63.426,2.751 63.426,4.294"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#677BC5"
      d="M60.582,6.031 C60.582,6.031 59.813,6.707 64.813,12.637 C69.812,18.567 73.557,21.26 74.17,28.183 C74.783,35.106 77.424,39.856 80.085,44.217 C82.745,48.578 88.115,69.144 88.115,69.144 C88.115,69.144 90.406,73.79 91.987,73.29 C93.568,72.79 100.591,70.569 100.591,70.569 C100.591,70.569 101.399,65.721 98.38,55.775 C95.36,45.828 90.148,29.887 85.835,20.425 C81.521,10.963 79.482,9.25 73.958,7.087 C68.434,4.924 65.005,3.626 65.005,3.626 L60.582,6.031 Z"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#677BC5"
      d="M43.374,6.031 C43.374,6.031 44.143,6.707 39.143,12.637 C34.144,18.567 30.399,21.26 29.786,28.183 C29.173,35.106 26.532,39.856 23.871,44.217 C21.211,48.578 15.841,69.144 15.841,69.144 C15.841,69.144 13.55,73.79 11.969,73.29 C10.388,72.79 3.365,70.569 3.365,70.569 C3.365,70.569 2.557,65.721 5.576,55.775 C8.596,45.828 13.808,29.887 18.121,20.425 C22.435,10.963 24.474,9.25 29.998,7.087 C35.522,4.924 38.951,3.626 38.951,3.626 L43.374,6.031 Z"
    />
    <path d="M51.978,83.171 C61.331,83.171 67.619,82.364 71.716,81.471 C71.716,81.471 75.574,80.538 78.508,79.12 C78.508,79.12 74.807,61.129 74.779,34.033 L80.085,44.217 C80.085,44.217 86.395,65.257 88.115,69.144 C89.836,73.031 91.987,73.29 91.987,73.29 L94.569,78.322 L102.456,76.273 L100.592,70.569 C102.886,68.237 96.72,50.617 93.135,38.568 C89.55,26.519 82.049,11.627 78.001,8.899 C76.437,7.845 63.163,2.939 63.163,2.939 C59.292,1.255 51.978,1.514 51.978,1.514" />
    <path d="M51.978,7.087 C51.978,7.087 65.458,6.956 63.163,2.939" />
    <path d="M60.582,7.733 L68.492,16.901 C72.678,21.754 74.809,27.756 74.779,33.909 L74.779,34.034" />
    <path d="M51.978,1.514 C51.978,1.514 44.664,1.255 40.793,2.939 C40.793,2.939 27.424,7.739 25.955,8.899 C21.779,12.195 14.406,26.519 10.821,38.568 C7.236,50.617 1.07,68.237 3.364,70.569 L1.5,76.273 L9.387,78.322 L11.969,73.29 C11.969,73.29 14.12,73.031 15.84,69.144 C17.561,65.257 23.871,44.217 23.871,44.217 L29.177,34.033 C29.149,61.129 25.448,79.12 25.448,79.12 C25.448,79.12 31.105,83.171 51.978,83.171" />
    <path d="M51.978,7.087 C51.978,7.087 38.498,6.956 40.793,2.939" />
    <path d="M43.374,7.733 L35.464,16.901 C31.278,21.754 29.147,27.756 29.177,33.909 L29.177,34.034" />
    <path d="M3.364,70.569 L11.968,73.29" />
    <path stroke="#3A427C" d="M100.591,70.569 L91.987,73.29" />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#283060"
      d="M84.151,81.888 C85.463,80.016 86.754,78.123 88.087,76.264 C87.204,75.203 86.79,73.741 87.278,71.996 C87.563,70.979 87.82,69.959 88.064,68.938 C88.382,57.506 90.001,46.155 91.43,34.813 C91.532,33.989 91.799,33.278 92.165,32.662 C89.859,31.878 86.623,31.175 82.4,31.175 C73.061,31.175 67.537,35.167 67.305,35.336 C66.951,35.597 66.745,36.014 66.749,36.455 C66.755,36.902 66.924,47.548 69.769,59.298 C70.269,61.08 71.572,66.134 71.572,68.11 C71.572,69.152 71.287,70.108 70.957,71.216 C70.573,72.514 70.135,73.986 70.135,75.808 C70.135,77.674 70.531,79.332 70.894,80.466 C70.654,80.712 70.505,81.048 70.505,81.419 C70.505,81.808 70.516,82.167 70.528,82.523 C73.475,81.891 76.409,81.195 79.364,80.593 C81.197,80.22 82.941,80.686 84.151,81.888"
      opacity={0.2}
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      d="M106.309,88.903 C101.508,88.903 96.973,88.903 93.483,86.974 C93.026,86.721 92.62,86.51 92.242,86.317 L90.657,85.508 L89.62,87.067 L87.784,88.903 L78.488,88.903 C78.075,88.882 76.667,87.475 76.636,81.517 L77.335,80.799 L76.967,79.654 C76.629,78.606 76.228,76.975 76.228,75.156 C76.228,73.451 76.644,72.049 77.046,70.694 C77.438,69.377 77.805,68.141 77.805,66.71 C77.805,63.834 75.835,56.797 75.752,56.499 C72.929,44.839 72.562,34.069 72.519,32.215 C73.633,31.465 79.021,28.183 87.685,28.183 C96.148,28.183 100.764,30.924 101.738,31.572 C101.723,39.324 101.078,50.528 100.37,55.236 C99.809,58.961 99.717,64.531 100.155,68.195 L100.169,68.317 L100.199,68.433 C100.229,68.559 100.269,68.772 100.286,69.069 L100.292,69.186 L100.312,69.3 C100.485,70.293 100.699,71.001 100.984,71.526 C102.286,73.924 109.5,78.106 111.001,78.513 L111.146,78.552 L111.294,78.57 C111.468,78.591 111.789,78.608 113.312,78.677 C115.936,78.796 121.21,79.035 122.304,79.617 C122.838,79.9 123.314,80.603 123.644,81.594 L123.995,82.648 L124.241,82.709 L124.16,82.793 C119.793,87.056 110.236,88.903 106.309,88.903"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#677BC5"
      d="M72.29,37.269 C72.29,37.269 77.362,33.119 86.389,33.119 C95.416,33.119 98.629,34.251 101.663,36.347 L101.738,31.572 C101.738,31.572 98.548,27.89 86.389,27.89 C74.229,27.89 72.014,32.579 72.014,32.579 L72.29,37.269 Z"
    />
    <polyline
      stroke="none"
      strokeWidth={1}
      fill="#E8EBF7"
      points="89.699 27.889 89.699 35.946 86.389 38.349 83.078 35.946 83.078 28.402"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#677BC5"
      d="M77.701,68.032 C77.701,68.032 84.248,75.857 93.303,75.857 C102.361,75.857 98.626,69.637 102.103,71.93 C105.581,74.223 106.639,77.334 111.778,78.101 C115.296,78.625 119.9,78.736 122.829,79.799 C124.177,80.289 125.171,81.768 125.54,82.175 C125.54,82.175 117.052,88.91 104.936,88.91 C99.775,88.91 93.177,86.528 90.959,87.236 C89.094,87.831 91.499,88.491 88.879,88.904 C87.297,89.153 82.57,89.312 80.537,89.312 C74.704,89.312 76.442,83.171 76.442,83.171 C76.337,84.901 76.135,73.74 76.135,73.74 L77.701,68.032 Z"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#283060"
      d="M85.716,81.312 L76.636,81.312 L76.33,81.913 C76.356,82.656 76.383,83.181 76.406,83.314 C76.195,84.198 75.206,89.312 80.537,89.312 C82.57,89.312 87.298,89.153 88.88,88.904 C91.499,88.491 89.094,87.831 90.958,87.236 C93.177,86.527 99.776,88.91 104.937,88.91 C117.052,88.91 125.539,82.175 125.539,82.175 C125.172,81.768 124.178,80.289 122.829,79.799 C122.829,79.799 117.074,85.019 105.534,85.019 C93.994,85.019 93.576,81.312 85.716,81.312"
      opacity={0.2}
    />
    <path d="M90.109,87.284 L87.99,89.402 L78.487,89.402 C78.487,89.402 76.135,89.3 76.135,81.312" />
    <path d="M88.595,85.379 C88.595,85.379 89.901,85.565 93.241,87.411 C96.844,89.402 101.386,89.402 106.309,89.402 C111.232,89.402 121.421,86.998 125.2,82.418" />
    <path d="M124.501,83.171 C124.501,83.171 124.168,80.04 122.54,79.175 C120.911,78.31 112.312,78.208 111.244,78.055 C110.175,77.903 102.696,73.629 101.424,71.288 C100.152,68.948 100.152,60.043 100.864,55.311 C101.576,50.579 102.238,39.045 102.238,31.311 C102.238,31.311 97.557,27.682 87.686,27.682 C77.815,27.682 72.014,31.956 72.014,31.956 C72.014,31.956 72.167,43.812 75.271,56.634 C75.271,56.634 77.306,63.859 77.306,66.709 C77.306,69.558 75.728,71.746 75.728,75.155 C75.728,78.564 77.067,81.312 77.067,81.312" />
    <polyline
      strokeWidth={1.5}
      points="89.699 27.889 89.699 35.946 86.389 38.349 83.078 35.946 83.078 28.402"
    />
    <path d="M100.671,68.247 C100.671,68.247 101.881,72.764 96.386,75.206 C90.891,77.649 81.58,72.866 77.306,66.709" />
    <path strokeWidth={1.5} d="M89.665,75.385 C89.665,75.385 87.94,72.103 87.94,65.742" />
    <path strokeWidth={1.5} d="M86.389,38.349 C86.389,38.349 86.515,43.456 86.922,48.239" />
  </svg>
);

export default Clothing;



// WEBPACK FOOTER //
// ./src/assets/images/icons/clothing.js